<template>
    <span>
      <b-card no-body>
        <b-card-header>
          <b-row>
            <b-col md="7" lg="9">
              <h3 tabindex="0">Listar Propostas</h3>
            </b-col>
            <b-col md="5" lg="3">
              <b-button v-if="!is_admin" @click="navigate('/proposta/sugestao/cadastrar')" block variant="primary">
                    <i class="fa fa-plus"></i>
                  <span>Adicionar Proposta</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-col sm="12" md="6">
              <b-form-group label="Título do Caderno:">
                <b-form-input type="text" id="name" v-model="filtros.filter" placeholder="Título do Caderno"></b-form-input>
              </b-form-group>
            </b-col>
             <b-col sm="12" md="6">
                <b-form-group label="Situação:">
                    <b-form-select v-model="filtros.situacao" placeholder="Situação" class="mb-3">
                          <option selected :value="null">Selecione</option>
                          <option v-for="item in situacoes" :key="item.id" :value="item.value"> {{item.text}}</option>
                    </b-form-select>
                </b-form-group>
              </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="4" lg="3">
              <b-button block variant="primary" @click="pesquisar">
                <i class="fa fa-search"></i>&nbsp;&nbsp;<span>Pesquisar</span>
              </b-button>
            </b-col>  
         </b-row>
        </b-card-body>
        <b-row>
          <b-col sm="12">
            <b-container fluid>
              <span>
                <table selectable aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7" class="table table-responsive-sm table-bordered table-striped table-sm">
                  <thead>
                    <tr>
                      <th v-if="is_admin" tabindex="0" scope="col" style="width: 8%"><input type="checkbox" @click="selectAll" v-model="allSelected"> Enviar</th>
                      <th scope="col" tabindex="0">Proposta</th>
                      <th scope="col" tabindex="0">Caderno</th> 
                      <th scope="col" tabindex="0">Situação</th>
                      <th scope="col" tabindex="0">Ações</th>
                    </tr>
                  </thead>

                  <tbody v-if="propostas.data !== undefined">
                    <tr class="action" v-for="proposta in propostas.data" :key="proposta.id">    
                       <td v-if="is_admin">
                        <label class="form-checkbox">
                          <div class="custom-control custom-checkbox custom-control-inline">
                            <input type="checkbox" class="custom-control-input" :id="'defaultInline1' + proposta.id" :value="proposta.id" v-model="selecionados" :disabled="proposta.situacao !== 'A'">
                            <label class="custom-control-label" :for="'defaultInline1' + proposta.id"></label>
                          </div>
                        </label>
                      </td>         
                      <td tabindex="0">{{proposta.texto | sliceContent}}</td>
                      <td tabindex="0">{{proposta.titulo | sliceContent}}</td>
                      <td tabindex="0" v-if="proposta.situacao == 'S'">Salvo</td>
                      <td tabindex="0" v-if="proposta.situacao == 'E'">Enviado</td>
                      <td tabindex="0" v-if="proposta.situacao == 'A'">Aprovado</td>
                      <td tabindex="0" v-if="proposta.situacao == 'R'">Suspenso</td>
                      <td style="width: 15%">
                          <b-button v-if="proposta.situacao == 'S'" class="btn btn-sm btn-secondary action" title="Editar" @click="editarProposta(proposta.id)">
                            <i class="fa fa-pencil-square-o"></i>
                          </b-button>

                          <b-button class="btn btn-sm btn-secondary action" title="Visualizar" tabindex="0"  @click="visualizarProposta(proposta.id)">
                            <i class="fa fa-search"></i>
                          </b-button>

                          <b-button v-if="proposta.situacao == 'S' && !is_admin" class="btn btn-sm btn-secondary action" tabindex="0" title="Remover Proposta" @click="excluirProposta(proposta.id)">
                            <i class="fa fa-trash"></i>
                          </b-button>           

                          <b-button v-if="proposta.situacao !== 'E' && is_admin" class="btn btn-sm btn-secondary action" tabindex="0" title="Alterar Situação" @click="alterarSituacao(proposta.id)">
                           <i class="fa fa-external-link"></i>
                          </b-button>                                                         
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr class="action">
                      <td colspan="5" tabindex="0">Nenhuma proposta</td>
                    </tr>
                  </tbody>
                </table>
                <!-- <pagination tabindex="0" v-show="propostas.data !== undefined" :totalPorPagina="totalPorPagina" :resource="resource"></pagination> -->
              </span>
            </b-container>
          </b-col>
        </b-row>
           <b-card-footer v-if="is_admin" class="p-12">  
            <b-row>        
              <b-col v-if="!loading" sm="12" md="4" lg="2">
                <b-button block variant="primary" @click="enviarPropostas()" :disabled="this.selecionados.length == 0">
                  <span>Enviar Propostas</span>
                </b-button>
              </b-col>
              <b-col v-else sm="12" md="4" lg="2">
                <b-button block variant="primary" :disabled="true">
                  <b-spinner small type="grow"></b-spinner>Enviando...
                </b-button>
            </b-col>
            </b-row>
        </b-card-footer>
      </b-card>
    </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import {eventType} from '@/components/shared/eventType'
import {DatePicker, setupCalendar} from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'

setupCalendar({
  firstDayOfWeek: 2 // Monday
})

miniToastr.init()

export default {
  components: {
    Pagination,
    'v-date-picker': DatePicker,
    Multiselect
  },
  filters: {
    sliceContent: function(string) {
      string = string.replace(/<\/?[^>]+>/ig, " ")
      if(string.length > 100){
          return string.slice(0, 100) + '...'
      }
       return string     
    },
  },
  created () {
    if (!this.validaPerfil()) {
       //this.$router.push('/')
    }

    this.pesquisar()
  },
  data () {
    return {
      totalPorPagina: false,
      resource: 'proposta/sugerida',
      is_admin: null,
      selecionados: [],
      allSelected: false,
      loading: false,
      filtros: {
        filter: null,
        situacao: null
      },
      situacoes: [
        { value: 'E', text: 'Enviado' },
        { value: 'S', text: 'Salvo' },
        { value: 'A', text: 'Aprovado' },
        { value: 'R', text: 'Suspenso' }
      ],
    }
  },
  computed: {
    propostas () {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    },
    inputState () {
      if (!this.selectedValue) {
        return {
          type: 'is-danger',
          message: 'Data do cadastro'
        }
      }
      return {
        type: 'is-primary',
        message: ''
      }
    }
  },
  methods: {
    validaPerfil () {
       let perfil = this.$store.state.perfil.perfil     
       if (perfil.is_admin_conferencia) {
         this.is_admin = true
         return true
       }
       return false
    },
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    editarProposta (id) {
      this.$router.push('/proposta/sugestao/editar/' + id)
    },
    alterarSituacao (id) {
      this.$router.push('/proposta/sugestao/situacao/' + id)
    },
    pesquisar () {
      this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
      this.setarFiltros(this.filtros)
    },
    visualizarProposta (id) {
      this.$router.push('/proposta/sugestao/visualizar/' + id)
    },
    enviarPropostas (id) {
      this.$bvModal.msgBoxConfirm('Deseja enviar as propostas selecionadas?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.loading = true
          Vue.http.post('api/proposta/sugerida/enviar', {'propostas': this.selecionados}).then(response => {
            if (response.body.success) {
              this.selecionados = []
              this.loading = false
              console.log(this.loading)
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina})
            }
          }).catch(erro => {
            this.selecionados = []
            this.loading = false
            if (!erro.body.success) {        
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
              miniToastr.error(erro.body.msg, 'Alerta!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina})
            }
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    excluirProposta (id) {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.delete('api/proposta/sugerida/' + id, {}).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            } else {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }

            this.loading = false
          }).catch(e => {
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    selectAll(){
       this.selecionados = [];
        if (!this.allSelected) {
          for (var index in this.propostas.data) {
            if(this.propostas.data[index].situacao == 'A'){
              this.selecionados.push(this.propostas.data[index].id)
            }
          }
        }
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
    .multiselect.invalid .multiselect__tags,
    .multiselect.invalid .multiselect__tags span,
    .multiselect.invalid .multiselect__tags input {
        background:red;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/proporPropostas/PropostaSugestaoLista.vue